export class BaseFiltroInputDto {
  PaginaAtual: number | null;
  TamanhoPagina: number | null;

  constructor(PaginaAtual: number | null, TamanhoPagina: number | null) {
      this.PaginaAtual = PaginaAtual || 1;
      this.TamanhoPagina = TamanhoPagina || 10;
  }
}
